module.exports = __webpack_public_path__ + "static/media/finance.d81b5f84.svg";